<template>
  <div class="venue">
    <div class="venue-header">
      <h1 class="month">{{ show.month }}</h1>
      <h3 class="date">{{ show.date }}</h3>
      <p class="venue-name">@ {{ show.venue }}</p>
    </div>
    <div
      class="venue-image"
      :style="{ 'background-image': `url(${show.venueImage})` }"
    />
    <div class="venue-footer">
      <a
        target="_blank"
        rel="noopener"
        class="buy-tickets-link"
        :href="show.ticketUrl"
      >
        More info &amp; tickets
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "Venue",
  props: {
    show: {
      id: String,
      month: String,
      date: String,
      venue: String,
      ticketUrl: String,
      venueImage: String
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.venue {
  display: flex;
  flex-direction: column;
  width: 300px;
  margin: 20px;
  text-align: left;
}
h1,
h3,
p {
  margin: 0;
}
.month {
  text-transform: uppercase;
  font-weight: bold;
}
.date {
  font-weight: 800;
  font-size: 42px;
  color: #ef4037;
}

.venue-image {
  width: 300px;
  height: 150px;
  background-size: cover;
}

.venue-footer {
  text-transform: uppercase;
  font-weight: 700;
  padding-top: 20px;
}

.buy-tickets-link {
  border-bottom: 2px #ef4037 solid;
}
</style>
